var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.82 5.58l-.82.822-.824-.824a5.375 5.375 0 00-7.6 7.602l7.894 7.895a.75.75 0 001.06 0l7.902-7.897a5.376 5.376 0 00-5.866-8.766A5.382 5.382 0 0012.82 5.58zm6.548 6.539L12 19.485 4.635 12.12a3.875 3.875 0 115.48-5.48l1.358 1.357a.75.75 0 001.073-.012L13.88 6.64a3.88 3.88 0 015.487 5.48",
    fill: "#333230"
  })));
}
export default SvgPldHeart;